import React from "react";
import axios from "axios";
import ApiComponent from "./ApiComponent";
import {array} from "prop-types";

class NewsApiComponent extends ApiComponent
{
    showNews(news_id, callback)
    {
        this.passport(res => {
            let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
            axios.get( backendBaseURL + "api/v1/news/" + news_id, {
                headers: { Authorization: `Bearer ${res.access_token}` },
                params: {
                    isGen4: false
                }
            }).then(res => {
                callback(res.data.data)
            }).catch(ex => {
                console.log(ex.message)
            })
        })
    }

    showNewsGen4(news_id, callback)
    {
        this.passport(res => {
            let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
            axios.get( backendBaseURL + "api/v1/news/" + news_id, {
                headers: { Authorization: `Bearer ${res.access_token}` },
                params: {
                    isGen4: true
                }
            }).then(res => {
                callback(res.data.data)
            }).catch(ex => {
                console.log(ex.message)
            })
        })
    }

    indexNews(news_category_id, limit, callback)
    {
        if(news_category_id === 0)
        {
            this.passport(res => {
                let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
                axios.get( backendBaseURL + "api/v1/news?sort=-id&limit=" + limit, {
                    headers: { Authorization: `Bearer ${res.access_token}` }
                }).then(res => {
                    console.log(res);
                    callback(res.data.data)
                }).catch(ex => {
                    console.log(ex.message)
                })
            })
        } else {
            if( Array.isArray(news_category_id) )
            {
                this.passport(res => {
                    let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
                    axios.get(backendBaseURL + "api/v1/news?news_category_ids=" + news_category_id.join(',') + "&sort=-id&limit=" + limit, {
                        headers: {Authorization: `Bearer ${res.access_token}`}
                    }).then(res => {
                        callback(res.data.data)
                    }).catch(ex => {
                        console.log(ex.message)
                    })
                })
            } else {
                this.passport(res => {
                    let backendBaseURL = process.env.REACT_APP_BACKEND_BASE_URL;
                    axios.get(backendBaseURL + "api/v1/news?news_category_id=" + news_category_id + "&sort=-id&limit=" + limit, {
                        headers: {Authorization: `Bearer ${res.access_token}`}
                    }).then(res => {
                        callback(res.data.data)
                    }).catch(ex => {
                        console.log(ex.message)
                    })
                })
            }
        }
    }

    render() {
        return (
            <div />
        );
    }
}

export default NewsApiComponent;
